function setFunctionName(obj, name) {
  Object.defineProperty(obj, 'name', {
    configurable: true,
    value: name,
  });
  return obj;
}

function _canSetFunctionName() {
  function Foo() {}
  try {
    setFunctionName(Foo, 'Bar');
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('runtime cannot set function names');
    }
    return false;
  }
  return Foo.name === 'Bar';
}

const _setFunctionName = _canSetFunctionName()
  ? setFunctionName
  : (obj, name) => obj;

export default _setFunctionName;
